import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import ProviderSidebar from "../../provider/components/ProviderSidebar";
import { getProviderProfile, updateBookingSettings } from "@/lib/providerProfile";

export default function ProveedorConfiguracionPage() {
  const { t } = useTranslation("provider");
  const [minDays, setMinDays] = useState("0");
  const [loading, setLoading] = useState(true);
  const [saving, setSaving] = useState(false);
  const [saved, setSaved] = useState(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    let cancelled = false;
    getProviderProfile()
      .then((p) => { if (!cancelled) setMinDays(String(p.minAdvanceBookingDays)); })
      .catch(() => { /* default */ })
      .finally(() => { if (!cancelled) setLoading(false); });
    return () => { cancelled = true; };
  }, []);

  const save = async () => {
    const n = Number(minDays);
    if (Number.isNaN(n) || n < 0 || n > 365) { setError(t("provider.cfg.range")); return; }
    setSaving(true);
    setSaved(false);
    setError(null);
    try {
      await updateBookingSettings(n);
      setSaved(true);
      setTimeout(() => setSaved(false), 3000);
    } catch (e) {
      setError(e instanceof Error ? e.message : t("provider.cfg.saveError"));
    } finally {
      setSaving(false);
    }
  };

  return (
    <div className="min-h-screen bg-offwhite pt-14 md:pt-20 pb-12">
      <div className="w-full px-4 md:px-8 lg:px-12">
        <div className="w-full">
          <div className="flex flex-col lg:flex-row gap-6 lg:gap-8">
            <ProviderSidebar />
            <div className="flex-1 min-w-0 max-w-2xl">
              <div className="bg-white rounded-2xl border border-gray-100 p-6 md:p-8">
                <h1 className="text-xl font-bold text-charcoal mb-1">{t("provider.cfg.title")}</h1>
                <p className="text-sm text-gray-500 mb-6">{t("provider.cfg.desc")}</p>
                {loading ? (
                  <div className="py-6 text-center text-gray-400 text-sm">{t("provider.loading")}</div>
                ) : (
                  <div className="space-y-5">
                    <div>
                      <label className="block text-sm font-medium text-charcoal mb-1.5">{t("provider.cfg.minDays")}</label>
                      <input
                        type="number"
                        min={0}
                        max={365}
                        value={minDays}
                        onChange={(e) => setMinDays(e.target.value)}
                        className="w-32 px-4 py-2.5 border border-gray-200 rounded-lg text-sm focus:outline-none focus:border-ocean"
                      />
                      <p className="text-xs text-gray-400 mt-1">{t("provider.cfg.minDaysHint")}</p>
                    </div>
                    <div className="flex items-center gap-3">
                      <button onClick={save} disabled={saving} className="bg-ocean text-white text-sm font-medium px-6 py-2.5 rounded-full hover:bg-ocean/90 disabled:opacity-50">
                        {saving ? t("provider.saving") : t("provider.save")}
                      </button>
                      {saved && <span className="text-xs text-emerald-600">{t("provider.savedShort")}</span>}
                      {error && <span className="text-xs text-coral">{error}</span>}
                    </div>
                  </div>
                )}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
